import { QUICK_LIST_PRODUCT_CUSTOM_LIST_TYPE_ID } from '../constants/quickList.constants'

export const buildQuickListSearchPayload = ({
  pagination,
  status,
  searchText,
}) => ({
  ProductCustomListTypeId: QUICK_LIST_PRODUCT_CUSTOM_LIST_TYPE_ID,
  PageNumber: pagination.currentPage,
  PageSize: pagination.pageSize,
  Status: status,
  Search: searchText || '',
})

export const extractQuickListItems = searchResponseData =>
  (searchResponseData || []).flatMap(
    group => group?.ListDetailProductCustomList || []
  )

export const extractQuickListTotal = searchResponseData => {
  const total = searchResponseData?.[0]?.TotalRegisters
  return typeof total === 'number' ? total : null
}
